/* bios-cookies-toggle.js — small [COOKIES] toggle in the bottom-right that
   replaces Shopify's default consent banner. Reads/writes the cookie
   consent state via window.Shopify.customerPrivacy (the API is exposed
   automatically when Customer Privacy is enabled in the Shopify admin).
   Amber when consent granted, grey otherwise. */
(function biosCookiesToggle() {
  'use strict';

  /* Render the [COOKIES] toggle ONLY on the welcome portal screen. Two
     gates apply:
       1. Path must be home ("/" or ""), otherwise this is a secondary
          surface (PDP, cart, search, etc.) — skip entirely.
       2. The portal must not have already been dismissed this session
          (returning visitors auto-skip into [EXPERIENCE]); if it has,
          we'd be rendering the toggle on top of the catalog, which the
          spec says should never happen.
     We also listen for `bios:portal-done` to hide the toggle if the
     user dismisses the portal during this session. */
  var path = location.pathname;
  if (path !== '/' && path !== '') return;
  try {
    if (sessionStorage.getItem('bios_portal_choice')) return;
  } catch (_) {}

  function getPrivacyAPI() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  /* Reads consent state. Prefers Shopify's customer-privacy API; falls
     back to our own localStorage flag if the API hasn't loaded yet (so
     the visual state survives reloads even before Shopify has booted
     its async privacy module). */
  function userCanBeTracked() {
    var api = getPrivacyAPI();
    try {
      if (api && typeof api.userCanBeTracked === 'function') {
        return !!api.userCanBeTracked();
      }
    } catch (_) {}
    try {
      return localStorage.getItem('bios_cookies_on') === '1';
    } catch (_) {}
    return false;
  }

  function setConsent(accept, cb) {
    /* Mirror to localStorage immediately so sync() reads the right
       value even if Shopify's setTrackingConsent callback is slow or
       doesn't fire at all. */
    try {
      localStorage.setItem('bios_cookies_on', accept ? '1' : '0');
    } catch (_) {}
    var api = getPrivacyAPI();
    if (!api || typeof api.setTrackingConsent !== 'function') { if (cb) cb(); return; }
    try {
      api.setTrackingConsent({
        marketing: accept,
        analytics: accept,
        preferences: accept,
        sale_of_data: accept
      }, function () { if (cb) cb(); });
    } catch (_) { if (cb) cb(); }
  }

  function ensureToggle() {
    var toggle = document.getElementById('bios-cookies-toggle');
    if (toggle) return toggle;
    toggle = document.createElement('button');
    toggle.id   = 'bios-cookies-toggle';
    toggle.className = 'bios-cookies-toggle';
    toggle.type = 'button';
    toggle.setAttribute('aria-label', 'Toggle cookie consent');
    toggle.setAttribute('aria-pressed', 'false');
    /* Tagged so bios-cursor.js fires the accent-click glitch on press. */
    toggle.setAttribute('data-accent-click', '');
    /* Bracket-close hover effect — text is just "COOKIES"; the [ and ]
       brackets are rendered by CSS pseudo-elements (.bios-cookies-toggle::
       before/after) so they can animate inward on hover, matching the
       portal nav button style. */
    toggle.textContent = 'COOKIES';
    document.body.appendChild(toggle);
    return toggle;
  }

  function init() {
    var toggle = ensureToggle();

    function paint(on) {
      toggle.classList.toggle('is-on', !!on);
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.title = 'Cookies: ' + (on ? 'enabled (click to disable)' : 'disabled (click to enable)');
    }
    function sync() { paint(userCanBeTracked()); }

    toggle.addEventListener('click', function () {
      /* Optimistic update — flip the visual immediately based on the
         user's intent, then call setConsent + re-sync from the API
         when its callback fires. Means the amber/grey colour change
         is instant on click rather than waiting on the async API. */
      var willBe = !userCanBeTracked();
      paint(willBe);
      setConsent(willBe, sync);
      try { if (window.BiosAudio) window.BiosAudio.highlightPiezo(); } catch (_) {}
    });

    sync();

    /* Portal dismissed → user is now in [EXPERIENCE]. Spec says the
       cookies toggle should only appear on the welcome screen, so we
       hide it (and stop syncing) once portal-done fires. The toggle
       is re-created on next page load if the user returns to /. */
    document.addEventListener('bios:portal-done', function () {
      if (toggle && toggle.parentNode) toggle.parentNode.removeChild(toggle);
    });

    /* Shopify dispatches these as the privacy API initializes / state
       changes from other surfaces. Resync the toggle each time. */
    ['visitorConsentCollected', 'trackingConsentAccepted', 'shopifycustomerPrivacyApiLoaded']
      .forEach(function (evt) { document.addEventListener(evt, sync); });

    /* The privacy API can attach after DOMContentLoaded (it's async loaded
       by Shopify). Poll briefly until it shows up so the initial state
       reads correctly. */
    var tries = 0;
    var pollId = setInterval(function () {
      tries++;
      if (getPrivacyAPI() || tries > 30) { sync(); clearInterval(pollId); }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
